import PropTypes from "prop-types"
import { map, size } from "lodash"
import { Typography } from "@mui/material"
import MetricsSearch from "./metrics-search"
import MetricsCategory from "./metrics-category"
import { AvailableMetricsShape } from "./helpers/prop-types"
import "./styles.scss"

const MAX_COLUMNS = 20

export default function MetricSelection({
  includeMetricTypes,
  filteredMetrics,
  selectedMetrics,
  metricsSearchValue,
  setMetricsSearchValue,
  setSelectedMetrics,
  shouldFocus,
  analytics,
}) {
  const disableOptions = selectedMetricCount >= MAX_COLUMNS
  const selectedMetricCount = size(selectedMetrics)
  const { trackCategoryExpanded, trackCategoryCollapsed, trackMetricToggled } = analytics ?? {}

  return (
    <div className="metrics-selection-wrapper">
      <div className="metrics-selection-header">
        <Typography
          noWrap
          sx={{
          color: "inherit",
        }}
        >
          Available Metrics
        </Typography>
      </div>
      <MetricsSearch
        shouldFocus={shouldFocus}
        metricsSearchValue={metricsSearchValue}
        setMetricsSearchValue={setMetricsSearchValue}
        analytics={analytics}
      />
      <div className="metrics-selector-list">
        {map(filteredMetrics, category => {
          if (!category.items) {
            return null
          }
          return <MetricsCategory
            key={category.id}
            category={category}
            disableOptions={disableOptions}
            setSelectedMetrics={setSelectedMetrics}
            selectedMetrics={selectedMetrics}
            includeMetricTypes={includeMetricTypes}
            metricsSearchValue={metricsSearchValue}
            onCategoryExpanded={trackCategoryExpanded}
            onCategoryCollapsed={trackCategoryCollapsed}
            onMetricToggled={trackMetricToggled}
          />
        })}
      </div>
    </div>
  )
}

MetricSelection.propTypes = {
  filteredMetrics: AvailableMetricsShape,
  selectedMetrics: PropTypes.arrayOf(PropTypes.string).isRequired,
  setSelectedMetrics: PropTypes.func.isRequired,
  metricsSearchValue: PropTypes.string.isRequired,
  setMetricsSearchValue: PropTypes.func.isRequired,
  includeMetricTypes: PropTypes.bool,
  shouldFocus: PropTypes.bool,
  analytics: PropTypes.object,
}
